import { observer } from 'mobx-react';
import * as React from 'react';
import { ISocialButtonWrapperConfig, SocialComponent } from '~domain/entities/Config';
import { SocialButtonWrapper } from '~components/SocialButtonWrapper';
import { classes } from '~utils/Classes';
import { useTranslation } from '~utils/hooks/translations';

export interface ISocialPositionWrapperProps {
    children: React.ReactElement;
    socialWrapperConfig?: ISocialButtonWrapperConfig;
    hideSocialButtons?: boolean;
}

export const socialWrapperMessageClassNames = classes('social-wrapper-message');
export const socialWrapperDividerClassNames = classes('social-wrapper-divider');
export const socialWrapperDividerTextClassNames = classes('social-wrapper-divider-text');

export const SocialPositionWrapper = observer((props: ISocialPositionWrapperProps) => {
    const { children, socialWrapperConfig, hideSocialButtons } = props;
    const { wrapperPosition, wrapperLayout = [], messageLabelKey = '', dividerLabelKey = '' } =
        socialWrapperConfig || {};
    const { [messageLabelKey]: messageLabel, [dividerLabelKey]: dividerLabel } = useTranslation();

    if (hideSocialButtons || !wrapperPosition) {
        return children;
    }
    const renderWrapper = () => {
        if (wrapperLayout.length > 0) {
            return wrapperLayout.map((item) => {
                switch (item) {
                    case SocialComponent.MESSAGE:
                        return (
                            <div
                                className={socialWrapperMessageClassNames}
                                dangerouslySetInnerHTML={{
                                    __html: messageLabel
                                }}
                            />
                        );
                    case SocialComponent.DIVIDER:
                        return (
                            <div className={socialWrapperDividerClassNames}>
                                <span className={socialWrapperDividerTextClassNames}>
                                    {dividerLabel}
                                </span>
                            </div>
                        );
                    default:
                        return <SocialButtonWrapper />;
                }
            });
        }

        return <SocialButtonWrapper />;
    };

    switch (wrapperPosition) {
        case 'top':
            return (
                <>
                    {renderWrapper()} {children}
                </>
            );
        case 'bottom':
            return (
                <>
                    {children} {renderWrapper()}
                </>
            );
        default:
            return children;
    }
});
